import { RouterProvider } from "react-router-dom";
import { AlertProvider } from "../components/AlertProvider";
import { router } from "../routes";

function App() {
  return (
      <AlertProvider>
          <RouterProvider router={router} />
      </AlertProvider>
  );
}

export default App;
